<template>
  <div
    class="block-wrap block-specification"
    style="padding:10px">
    <div
      v-for="(s, sindex) in specifications"
      :key="s.nameKey">
      <div class="title-bg">
        规格名：
        <template>
          <el-select
            v-model="s.name"
            style="width:140px"
            @change="(value) => handleSpecNameChanged(value, sindex, s)"
            @focus="handleSpecNameFocus(s.name, s.nameKey)"
          >
            <template v-for="(op, opIndex) in schemaSpecs">
              <el-option :key="opIndex" :label="op.name" :value="op.name" />
            </template>
          </el-select>
          <el-button
            v-if="supportRemark(s.nameKey)"
            style="float: right; margin-right: 8px"
            type="link"
            @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
          <span v-if="s.ui.rules && s.ui.rules.allowCreate" style="margin-left: 40px;font-size: 12px;"><i class="el-icon-warning" style="font-size: 16px; color: #E6A23C;"></i>该规格下规格值支持<span style="color: #E6A23C;">自定义</span></span>
        </template>
      </div>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left:10px;">规格值：</div>
        <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" handle=".drag-icon-wrap" :group="{ name: s.nameKey, pull: 'clone', put: false }" :animation="500">
          <div
            v-for="(v, vi) in s.values"
            :key="v.valueKey"
            class="specification-value-flex_item">
            <div class="del-input-wrap">
              <el-select
                v-if="['SINGLECHECK', 'MULTICHECK'].includes(s.ui.type)"
                :placeholder="s.ui.rules && s.ui.rules.allowCreate ? '请选择或输入' : '请选择'"
                :allow-create="s.ui.rules && s.ui.rules.allowCreate"
                :blur-create="s.ui.rules && s.ui.rules.allowCreate"
                filterable
                default-first-option
                :ref="`${sindex}-${vi}`"
                @change="(e) => selectedHandle(sindex, vi, e, v)" 
                @focus="() => handleSelectFocus(sindex, vi)"
                class="specification-value-flex_input"
                v-model="v.value"
                :class="{'warning': valueItemIsWarning(s.ui, v) }"
                >
                <el-option
                  v-for="op in getOptionsForSelect(sindex, vi)"
                  :key="op.value"
                  :value="op.value"
                  :label="op.displayName"
                  :disabled="s.values.findIndex(_v => _v.value === op.value) > -1"
                >
                  {{ op.displayName }}
                </el-option>
              </el-select>
              <el-input
                v-else
                placeholder="请输入"
                :ref="`${sindex}-${vi}`"
                @blur="(e) => blurHandle(sindex, vi, e)" class="specification-value-flex_input"
                @keyup.enter.native="(e) => valueEnter(sindex, vi)"
                @input="(e) => valueInput(v)"
                v-model="v.value"></el-input>
              <el-checkbox
                style="margin-left: 8px"
                v-model="v.checked"
                @change="e => onChangeCheckbox(v)"
                :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"></el-checkbox>
              <drag-item-content></drag-item-content>
            </div>
            <div v-if="v.valueErrorMsg" class="el-form-item__error">{{ v.valueErrorMsg }} </div>
            <!-- 天猫的扩展字段 -->
            <template v-if="getExtendsField(s.nameKey)">
              <ExtendsFields
                :fileds="getExtendsField(s.nameKey)"
                :wrapData="v"
                :propName="s.nameKey"
                v-model="v.extendValues"
                @change="e => extendValuesChange(v)"
                >
                <template slot="prop_image">
                  <div class="specification-value-flex_img">
                    <ImgUpload
                      :width="80"
                      :height="80"
                      :file="v.imageUrl"
                      @upload-success="(url) => imageUploadSuccess(url, v)"
                      @del="() => imageUploadDel(v)"
                      :limitSuffix="imgLimitSuffix"
                      :isSingle="true"
                    />
                  </div>
                </template>
              </ExtendsFields>
            </template>
          </div>
        </vue-draggable>
      </div>
    </div>
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue';
import ExtendsFields from "./ExtendsFields.vue";
import { cloneDeep } from 'lodash';
import { dragItemMixin } from '@/components/prod/center/utils/mixins';

export default {
  components: {
    ImgUpload,
    ExtendsFields,
    BatchSetSpecRemarksDialog,
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      type: Array,
      default() {
        return []
      }
    },
    schemaSpecs: {
      type: Array,
      default() {
        return []
      }
    },
    showMode: {
      type: String,
      default: 'multi-select'
    },
    imgLimitSuffix: { // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif'
    },
  },
  data() {
    return {
      specifications: [],
      specOptions: [], // 规格名下拉框列表项
      selectLoading: false, // 规格名下拉框loading
      oldSpecName: null,
      oldSpecNameKey: null,
      activeSelect: false
    }
  },
  computed: {
  },
  watch: {
    values:{
      deep: false,
      handler(v) {
        this.specifications = v;
      },
      immediate: true
    }
  },
  mounted() {
     
  },
  methods: {
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        platform: 'tm',
        remarkKey: 'prop_remark',
        specifications: this.specifications,
        sureFn: (specs) => {
          console.log(specs, '----specs---')
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    handleSelectFocus(sindex, vi) {
      this.activeSelect = `${sindex}-${vi}`;
    },
    getOptionsForSelect(sindex, vi) {
      const currentSelectKey = `${sindex}-${vi}`;
      // 只有当前激活的select才返回options
      if (this.activeSelect === currentSelectKey) {
        return this.specifications[sindex].ui.options || [];
      }
      // 如果当前select有选中值，则只返回包含该值的option
      const currentValue = this.specifications[sindex].values[vi].value;
      if (currentValue) {
        return (this.specifications[sindex].ui.options || []).filter(op => op.value === currentValue);
      }
      return [];
    },
    getExtendsField(key) {
      if(this.showMode === 'single-custom') {
        return [
          { label: "备注", name: "prop_remark", type: "INPUT", rules: { maxLengthRule: "30", minLengthRule: "1"}},
          { label: "属性图片", name: "prop_image", type: "INPUT", rules: { requiredRule: "ture", valueTypeRule: "url"}},
        ]
      }
      const tmExtendsFields = this.$store.getters.tmExtendsFields
      if(key.startsWith('std_size_prop_') && tmExtendsFields['prop_remark']) {
        return cloneDeep(tmExtendsFields['prop_remark'])
      }
      return tmExtendsFields[key];
    },
    supportRemark(key) {
      const extendList = this.getExtendsField(key) || []
      return extendList.some(e => e.name === 'prop_remark')
    },
    handleSpecNameFocus(sName, sNameKey) {
      this.oldSpecName = sName;
      this.oldSpecNameKey = sNameKey;
    },
    handleSpecNameChanged(value, sIndex, s) {
      // this.$set(s, 'isEdited', true)
      const hasMachedIndex = this.specifications.findIndex((item, index) => item.name === value && sIndex !== index);
      const matchRule = this.schemaSpecs.find(item => item.name === value);
      this.specifications[sIndex].nameKey = matchRule.nameKey;
      this.specifications[sIndex].ui = matchRule.ui;
      if (hasMachedIndex > -1) {
        this.specifications[hasMachedIndex].name = this.oldSpecName;
        this.specifications[hasMachedIndex].nameKey = this.oldSpecNameKey;
        const matchOldRule = this.schemaSpecs.find(item => item.name === this.oldSpecName);
        this.specifications[hasMachedIndex].ui = matchOldRule.ui;
      }
    },
    valueItemIsWarning(sUi, specValuData) {
      const {options , rules } = sUi
      if (!rules.allowCreate && !options.some(item => item.value === specValuData.value)) {
        this.$set(specValuData, 'valueErrorMsg', '请选择枚举的属性值' )
        return true;
      } else {
        delete specValuData.valueErrorMsg
      }
      if (specValuData.trueValue === -1) {
        return false;
      }
      return false;
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`]
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus()
      }
    },
    // 规格值输入
    blurHandle(sindex, vi, e, {isSelect} = {}) {
      const _value = e.target.value
      if (!_value) return this.$message.error('请填写规格值')
      const values = this.specifications[sindex].values
      let isSame = false
      values.forEach((item, i) => {
        if (vi !== i && item.value === e.target.value) {
          isSame = true
        }
      })
      if (isSame) { 
        this.$message.error(`请勿${isSelect ? '选择' : '输入'}相同规格值`)
      }
    },
    // select类型选择
    selectedHandle(sindex, vi, v, itemV) {
      // this.$set(itemV, 'isEdited', true)
      const currentSpec = this.specifications[sindex];
      const optionHasMatch = (currentSpec.ui.options || []).find(op => {
        return op.value === v;
      })
      const propName = currentSpec.nameKey;
      currentSpec.values[vi].extendValues = currentSpec.values[vi].extendValues || {};
      if (optionHasMatch) {
        currentSpec.values[vi].trueValue = v;
        if (!currentSpec.values[vi].extendValues) {
          currentSpec.values[vi].extendValues = {}
        }
        currentSpec.values[vi].extendValues[propName] = optionHasMatch.value;
        currentSpec.values[vi].extendValues[`in_${propName}`] = '';
      } else {
        currentSpec.values[vi].trueValue = -1;
        if (!currentSpec.values[vi].extendValues) {
          currentSpec.values[vi].extendValues = {}
        }
        currentSpec.values[vi].extendValues[propName] = -1;
        currentSpec.values[vi].extendValues[`in_${propName}`] = v;
      }
      this.blurHandle(sindex, vi, {target: {value: v}}, {isSelect: true})
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      const _copy = [].concat(this.specifications[sindex].values)
      _copy.splice(index,1)
      this.specifications[sindex].values = _copy
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    valueInput(v) {
      // this.$set(v, 'isEdited', true)
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    onChangeCheckbox(v) {
      // this.$set(v, 'isEdited', true)
      window.__spcificationCheckbox_changed = true;
    },
    extendValuesChange(v) {
      // this.$set(v, 'isEdited', true)
    },
    // 添加规格值
    addSpValue(index) {
      let voidValue = {
        value: '',
        checked: true,
        valueKey: this.$utils.genkey.get('v')
      }
      if (index === 0) voidValue.imageUrl = '';
      this.specifications[index].values.push(voidValue)
      window.__spcificationImg_changed = voidValue.valueKey // 用于skuList生成时的图片取值规则
    },
    imageUploadSuccess(url, v) {
      // this.$set(v, 'isEdited', true)
      v.imageUrl = url;
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v) {
      // this.$set(v, 'isEdited', true)
      v.imageUrl = '';
      this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
    }
  }
}
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #DCDFE6;
  max-height: 444px;
  overflow-y: auto;

  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
  .specification-value {
    &-flex {
      display: inline-flex;
      flex-wrap: wrap;
      width: 90%;
      &_item {
        margin-right: 20px;
        margin-bottom: 15px;
      }
      
      &_img {
        width: 82px;
        height: 82px;
        margin-top: 10px;
        margin-bottom: 20px;
        position: relative;
      }
      .el-input {
        width: 160px;
      }
      
    }
    .el-form-item__error {
      margin-left: 0 !important;
      position: relative;
      top: 0px;
    }
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
}


.del-input-wrap {
  position: relative;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0,0,0,.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
  ::v-deep .el-select{
    &.warning{
      border-color: #f56c6c;
      .el-input{
        color: #000;
      }
      input.el-input__inner{
        border-color: #f56c6c;
      }
    }
  }
}
</style>